import { CalculatorBodyText, CalculatorHeadline, CalculatorInputHeadline, H3Headline } from "../CalculatorTypography";
import { MenuItem, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import Result1, { SecondPartOfTheResult } from "./Result1";
import {
  allFields,
  dropdown10Options,
  dropdown11Options,
  dropdown13Options,
  dropdown14Options,
  dropdown16Options,
  dropdown17Options,
  dropdown18Options,
  dropdown18OptionsFirst,
  dropdown3Options,
  dropdown3OptionsFirst,
  dropdown7Options,
  dropdown7cOptions,
  dropdown8Options,
  dropdown9Options,
  fieldsForFirstPart,
  sliderMarks,
  yesAndNoDropdown,
} from "./data";
import { currentYear, generateYears } from "./helpers/generateYears";
import { onlyNumbersRegexDE, onlyNumbersRegexEN } from "src/components/common/constants";

import { CalculatorButton } from "../components/CalculatorButton";
import { CalculatorButtonLinkCentered } from "../components/CalculatorButtonLinkCentered";
import { CalculatorImage } from "../CalculatorImage";
import CalculatorInputSection from "../CalculatorInputSection";
import CalculatorSlider from "../CalculatorSlider";
import { ErrorMessage } from "src/components/common/ErrorMessage";
import { InputHeader } from "../KalorienverbrauchRechner/InputHeader";
import { InputWithLabelAtTheBottom } from "../components/InputWithLabelAtTheBottom";
import LocaleLink from "src/components/Navigation/LocaleLink";
import Maennlich from "../icons/Maennlich";
import Result2 from "./Result2";
import { TheCycleverseTheme } from "src/theme";
import Weiblich from "../icons/Weiblich";
import { handleScroll } from "src/lib/handleScroll";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  link: {
    textDecoration: "underline",
    color: theme.openButtonColor,
    cursor: "pointer",
  },

  boldText: {
    fontWeight: 900,
  },

  bottomInputClass: {
    marginTop: "-30px",
  },

  buttonsContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },

  marginTopZero: {
    marginTop: 0,
  },

  checkboxContainer: {
    marginTop: "30px",
    fontSize: "medium",
  },

  genderContainer: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
  },

  genderWrapper: {
    height: "100px",
    width: "100px",
    margin: "0 20px",
    cursor: "pointer",
    marginBottom: "30px",
  },

  dividerContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
    marginTop: "50px",
  },

  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#bababa",
  },
  dividerLabel: {
    width: "40px",
    height: "40px",
    borderRadius: "20px",
    marginTop: "-20.5px",
  },

  imageSpacing: {
    marginTop: "80px",
    marginBottom: "50px",
  },

  greenParagraph: {
    fontSize: "24px",
    color: theme.lightGreen,
  },
}));

type Fields = {
  field1?: number;
  field2?: string;
  field3?: string;
  field4?: number;
  field5?: string;
  field5a?: number;
  field6?: number;
  field7?: string;
  field7a?: number;
  field7b?: number;
  field7c?: string;
  field8?: string;
  field9?: string;
  field9a?: string;
  field10?: string;
  field11?: string;
  field11a?: number;
  field12?: string;
  field13?: string;
  field14?: string;
  field15?: string;
  field16?: string;
  field16a?: string;
  field17?: string;
  field18?: string;
  field19a?: number;
  field19b?: number;
  field20a?: number;
  field20b?: number;
  field21a?: number;
  field21b?: number;
  field22?: number;
};

const LebenserwartungsrechnerComponent = () => {
  const classes = useStyles();
  const { t, lang } = useTranslation("lebenserwartungsrechner");
  const initialState = {
    field1: null,
    field2: null,
    field3: "dropdown3Option1",
    field4: 10,
    field5: "input5Label1",
    field5a: null,
    field6: 75,
    field7a: null,
    field7b: null,
    field7c: "moderate",
    field7: "no",
    field8: "dropdown8Option5",
    field9: "dropdown9Option1",
    field9a: "No",
    field10: "dropdown10Option4",
    field11: "dropdown11Option3",
    field11a: null,
    field12: null,
    field13: "dropdown13Option1",
    field14: "dropdown14Option2",
    field15: "",
    field16: "",
    field16a: "",
    field17: "",
    field18: "dropdown18Option1",
    field19a: null,
    field19b: null,
    field20a: null,
    field20b: null,
    field21a: null,
    field21b: null,
    field22: null,
  };

  const [fields, setFields] = useState<Fields>(initialState);
  const [labels, setLabels] = useState({
    field4: "< 30.000 €",
    field5: t("input5Label1"),
  });

  const [resultL, setResultL] = useState<number>();
  const [resultA, setResultA] = useState<number>();
  const [resultL2, setResultL2] = useState<number>();
  const [resultSj, setResultSj] = useState<string>();
  const [resultSm, setResultSm] = useState<string>();
  const [resultFj, setResultFj] = useState<string>();
  const [resultYj, setResultYj] = useState<string>();
  const [resultFm, setResultFm] = useState<string>();

  const [twentyIsChecked, setTwentyIsChecked] = useState(false);
  const [secondButtonClicked, setSecondButtonClicked] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, isTypeNumber?: boolean) => {
    const { name, value } = e.target;
    if (
      isTypeNumber &&
      ((lang === "en" && !onlyNumbersRegexEN.test(value)) || (lang === "de" && !onlyNumbersRegexDE.test(value)))
    ) {
      return false;
    }
    if (name === "field18" && value === "dropdown18Option2") {
      setFields({ ...fields, field19a: 0, field19b: 0, field18: value });
    } else {
      setFields({ ...fields, [name]: value });
    }
  };

  const generateLabelsForField3 = (fieldValue: number): void => {
    if (fieldValue < 30000) {
      setLabels({ ...labels, field4: "< 30.000 €" });
    } else if (fieldValue > 30000 && fieldValue < 40000) {
      setLabels({ ...labels, field4: "30.000 - 40.000 €" });
    } else if (fieldValue > 40000 && fieldValue < 50000) {
      setLabels({ ...labels, field4: "40.000 - 50.000 €" });
    } else if (fieldValue > 50000 && fieldValue < 70000) {
      setLabels({ ...labels, field4: "50.000 - 70.000 €" });
    } else if (fieldValue >= 70000) {
      setLabels({ ...labels, field4: "> 70.000 €" });
    }
  };

  const generateLabelsForField5 = (fieldValue: number): void => {
    let label: string;
    if (fieldValue === 10) {
      label = t("input5Label1");
      setLabels({ ...labels, field5: label });
    } else if (fieldValue === 20) {
      label = t("input5Label2");
      setLabels({ ...labels, field5: label });
    } else if (fieldValue === 30) {
      label = t("input5Label3");
      setLabels({ ...labels, field5: label });
    } else if (fieldValue === 40) {
      label = t("input5Label4");
      setLabels({ ...labels, field5: label });
    } else if (fieldValue === 50) {
      label = t("input5Label5");
      setLabels({ ...labels, field5: label });
    }
    setFields({ ...fields, field5: label });
  };

  const handleInputChanges = (name?: string, value?: any) => {
    if (name === "field4") {
      generateLabelsForField3(Number(value));
      setFields({ ...fields, [name]: value });
    } else if (name === "field5") {
      generateLabelsForField5(Number(value));
    } else {
      setFields({ ...fields, [name]: value });
    }
  };

  const showQuestion7 = (): boolean => {
    const { field7a, field7b } = fields;
    const result = Number(field7b) / (Number(field7a) / 100) ** 2;
    if (result > 25) {
      return true;
    } else {
      return false;
    }
  };

  const displayFirstErrorMessagesOnTwenty = (): boolean => {
    const { field20a, field20b, field21a, field21b } = fields;
    const firstResult = Number(field20a) * 60 + Number(field20b);
    const secondResult = Number(field21a) * 60 + Number(field21b);

    if (firstResult < secondResult) {
      return true;
    } else {
      return false;
    }
  };

  const displaySecondErrorMessagesOnTwenty = (): boolean => {
    const { field19a, field19b, field21a, field21b } = fields;
    const firstResult = Number(field19a) * 60 + Number(field19b);
    const secondResult = Number(field21a) * 60 + Number(field21b);

    if (firstResult < secondResult) {
      return true;
    } else {
      return false;
    }
  };

  const handleErrorsForFirstInputs = () => {
    for (let i = 0; i < fieldsForFirstPart.length; i++) {
      if (!fields[fieldsForFirstPart[i]] || fields[fieldsForFirstPart[i]].length === 0) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleErrors = () => {
    for (let i = 0; i < allFields.length; i++) {
      if (!fields[allFields[i]] || fields[allFields[i]].length === 0) {
        return false;
      } else {
        return true;
      }
    }
  };

  const calculateResults = (button: string) => {
    const {
      field1,
      field2,
      field3,
      field5a,
      field6,
      field7a,
      field7b,
      field7c,
      field7,
      field8,
      field9,
      field9a,
      field10,
      field11,
      field11a,
      field12,
      field13,
      field14,
      field15,
      field16,
      field16a,
      field17,
      field19a,
      field19b,
      field18,
      field22,
      field20a,
      field20b,
      field21a,
      field21b,
    } = fields;

    const { field4: field4Label, field5: field5Label } = labels;
    setErrorMessage(null);
    const thereIsError = handleErrorsForFirstInputs();
    const allFieldsAvailable = handleErrors();

    if (!thereIsError) {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    if (field3 === "dropdown3Option1") {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    if (button === "last-button" && field18 === "dropdown18Option1") {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    if (
      button === "last-button" &&
      ((!field19a && !field19b) || (field19a.toString().length === 0 && field19b.toString().length === 0)) &&
      fields?.field18 !== "dropdown18Option2"
    ) {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    if (
      button === "last-button" &&
      ((!field20a && !field20b) || (field20a.toString().length === 0 && field20b.toString().length === 0)) &&
      !twentyIsChecked
    ) {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    if (
      button === "last-button" &&
      ((field21a === null && field21b === null) ||
        (field21a && field21a.toString().length === 0 && field21b && field21b.toString().length === 0))
    ) {
      setErrorMessage(t("errorMessage1"));
      return;
    }

    let M: number;
    let E: number;
    let F: number;
    let P: number;
    let B: number;
    let G: number;
    let K: number;
    let C: number;
    let T: number;
    let S: number;
    let X: number;
    let D: number;
    let R: number;
    let O: number;
    let A: number;
    let g: number;
    let Sx: number;

    // A → Life expectancy at birth
    if (Number(field1) >= 1930 && Number(field1) <= 1940) {
      A = 63;
    } else if (Number(field1) >= 1941 && Number(field1) <= 1950) {
      if (field2 === "männlich") {
        A = 64;
      } else {
        A = 67;
      }
    } else if (Number(field1) >= 1951 && Number(field1) <= 1960) {
      if (field2 === "männlich") {
        A = 66;
      } else {
        A = 71;
      }
    } else if (Number(field1) >= 1961 && Number(field1) <= 1970) {
      if (field2 === "männlich") {
        A = 68;
      } else {
        A = 74;
      }
    } else if (Number(field1) >= 1971 && Number(field1) <= 1980) {
      if (field2 === "männlich") {
        A = 69;
      } else {
        A = 75;
      }
    } else if (Number(field1) >= 1981 && Number(field1) <= 1990) {
      if (field2 === "männlich") {
        A = 72;
      } else {
        A = 79;
      }
    } else if (Number(field1) >= 1991 && Number(field1) <= 2000) {
      if (field2 === "männlich") {
        A = 74;
      } else {
        A = 84;
      }
    } else if (Number(field1) >= 2001 && Number(field1) <= 2010) {
      if (field2 === "männlich") {
        A = 76;
      } else {
        A = 82;
      }
    } else if (Number(field1) >= 2011 && Number(field1) <= 2020) {
      if (field2 === "männlich") {
        A = 78;
      } else {
        A = 83;
      }
    } else if (Number(field1) >= 2021 && Number(field1) <= 2030) {
      if (field2 === "männlich") {
        A = 79;
      } else {
        A = 84;
      }
    }

    setResultA(A);

    //M
    if (field3 === "dropdown3Option4" || field3 === "dropdown3Option5" || field3 === "dropdown3Option6") {
      M = 2;
    } else if (field3 === "dropdown3Option2" || field3 === "dropdown3Option3") M = 0;

    //E
    if (field4Label === "< 30.000 €") {
      E = 0.947;
    } else if (field4Label === "30.000 - 40.000 €") {
      E = 0.977;
    } else if (field4Label === "40.000 - 50.000 €") {
      E = 1;
    } else if (field4Label === "50.000 - 70.000 €") {
      E = 1.013;
    } else if (field4Label === "> 70.000 €") {
      E = 1.061;
    }

    //F
    if (field2 === "männlich") {
      const result = Number(currentYear) - Number(field1) - Number(field5a);
      if (field5Label === "input5Label1") {
        F = 0.903;
      } else if (field5Label === "input5Label2") {
        F = 0.94;
      } else if (field5Label === "input5Label3") {
        F = 1.074;
      } else if (field5Label === "input5Label5") {
        F = 1.074;
      } else if (field5Label === "input5Label4" && result <= 50) {
        F = 0.903;
      } else if (result > 50 && result < 60) {
        F = 0.964;
      } else if (result >= 60) {
        F = 1.024;
      }
    }

    //F
    if (field2 === "weiblich") {
      const result = Number(currentYear) - Number(field1) - Number(field5a);
      if (field5Label === "input5Label1") {
        F = 0.96;
      } else if (field5Label === "input5Label2") {
        F = 1;
      } else if (field5Label === "input5Label3") {
        F = 1.052;
      } else if (field5Label === "input5Label5") {
        F = 1.052;
      } else if (field5Label === "input5Label4" && result <= 50) {
        F = 0.96;
      } else if (result > 50 && result < 60) {
        F = 0.964;
      } else if (result >= 60) {
        F = 0.987;
      }
    }

    //P
    if (field2 === "männlich") {
      P = field6 * 0.96;
    } else if (field2 === "weiblich") {
      P = field6 * 1.03;
    }

    const years = currentYear - field1;

    const BMI = Number(field7b) / (Number(field7a) / 100) ** 2;

    //B
    if (BMI <= 25) {
      B = 1;
    } else if (BMI <= 18.5 && years <= 40) {
      B = -4.5;
    }

    if (field2 === "männlich") {
      if (field7 === "no") {
        if (years <= 40) {
          if (BMI > 25 && BMI < 30) {
            B = -2.7;
          } else if (BMI >= 30 && BMI < 35) {
            B = -5.9;
          } else if (BMI >= 35) {
            B = -8.4;
          }
        } else if (years > 40) {
          if (BMI < 30) {
            B = 1;
          } else if (BMI > 30) {
            B = -4.2;
          }
        }
      } else if (field7 === "yes") {
        if (years <= 40) {
          if (field7c === "high") {
            if (BMI > 25 && BMI < 30) {
              B = -2;
            } else if (BMI >= 30 && BMI < 35) {
              B = -4;
            } else if (BMI >= 35) {
              B = -6;
            }
          } else if (field7c === "moderate") {
            if (BMI > 25 && BMI < 30) {
              B = -1;
            } else if (BMI >= 30 && BMI < 35) {
              B = -2;
            } else if (BMI >= 35) {
              B = -3;
            }
          } else if (field7c === "low") {
            B = 0;
          }
        } else if (years > 40) {
          if (field7c === "high") {
            if (BMI > 25 && BMI < 30) {
              B = -1;
            } else if (BMI >= 30 && BMI < 35) {
              B = -2;
            } else if (BMI >= 35) {
              B = -3;
            }
          } else if (field7c === "low" || field7c === "moderate") {
            B = 0;
          }
        }
      }
    } else if (field2 === "weiblich") {
      if (field7 === "no") {
        if (years <= 40) {
          if (BMI > 25 && BMI < 30) {
            B = -2.6;
          } else if (BMI >= 30 && BMI < 35) {
            B = -5.6;
          } else if (BMI >= 35) {
            B = -6.1;
          }
        } else {
          if (BMI < 30) {
            B = 1;
          } else {
            B = -3.5;
          }
        }
      } else if (field7 === "yes") {
        if (years <= 40) {
          if (field7c === "high") {
            if (BMI > 25 && BMI < 30) {
              B = -2;
            } else if (BMI >= 30 && BMI < 35) {
              B = -3.5;
            } else if (BMI >= 35) {
              B = -4.5;
            }
          } else if (field7c === "moderate") {
            if (BMI > 25 && BMI < 30) {
              B = -1;
            } else if (BMI >= 30 && BMI < 35) {
              B = -2;
            } else if (BMI >= 35) {
              B = -3;
            }
          } else if (field7c === "low") {
            B = 0;
          }
        } else if (years > 40) {
          if (field7c === "high") {
            if (BMI > 25 && BMI < 30) {
              B = -1;
            } else if (BMI >= 30 && BMI < 35) {
              B = -2;
            } else if (BMI >= 35) {
              B = -3;
            }
          } else if (field7c === "low" || field7c === "moderate") {
            B = 0;
          }
        }
      }
    }

    //G
    if (field9 !== "dropdown9Option1" && field9 !== "dropdown9Option2") {
      if (field8 === "dropdown8Option1") {
        G = 15;
      } else if (field8 === "dropdown8Option2") {
        G = 10;
      } else if (field8 === "dropdown8Option3") {
        G = 5;
      } else if (field8 === "dropdown8Option4") {
        G = -2;
      } else if (field8 === "dropdown8Option5") {
        G = -5;
      }
    } else if (field9 === "dropdown9Option2") {
      if (field8 === "dropdown8Option1") {
        G = 4;
      } else if (field8 === "dropdown8Option2") {
        G = 2;
      } else if (field8 === "dropdown8Option3") {
        G = 0;
      } else if (field8 === "dropdown8Option4") {
        G = -2;
      } else if (field8 === "dropdown8Option5") {
        G = -5;
      }
    } else if (field9 === "dropdown9Option1") {
      if (field8 !== "dropdown8Option5") {
        G = -2;
      } else if (field8 === "dropdown8Option5") {
        G = -5;
      }
    }

    //F Meat consumption factor
    if (field9 === "dropdown9Option1") {
      F = -3;
    } else if (field9 === "dropdown9Option2") {
      F = -2;
    } else if (field9 === "dropdown9Option3") {
      F = 0.5;
    } else if (field9 === "dropdown9Option4") {
      F = 2;
    }

    if (field9a === "Yes") {
      K = 1.05;
    } else if (field9a === "No") {
      K = 1;
    }

    // C → Alcohol consumption factor
    if (field10 === "dropdown10Option1") {
      C = 2;
    } else if (field10 === "dropdown10Option2") {
      C = 0;
    } else if (field10 === "dropdown10Option3") {
      C = -0.5;
    } else if (field10 === "dropdown10Option4") {
      C = -1.5;
    } else if (field10 === "dropdown10Option5") {
      C = -4.5;
    } else if (field10 === "dropdown10Option6") {
      C = -7;
    }

    // T → Tabacco consumption factor
    if (field2 === "männlich") {
      if (field11 === "dropdown11Option1") {
        T = -5;
      } else if (field11 === "dropdown11Option2") {
        T = -2.5;
      } else if (field11 === "dropdown11Option3") {
        T = 2;
      } else if (field11 === "dropdown11Option4") {
        if (Number(field11a) <= 2) {
          T = 0;
        } else if (Number(field11a) > 3 && Number(field11a) <= 5) {
          T = -1.5;
        } else if (Number(field11a) > 5) {
          T = -3;
        }
      }
    }
    if (field2 === "weiblich") {
      if (field11 === "dropdown11Option1") {
        T = -4.5;
      } else if (field11 === "dropdown11Option2") {
        T = -2.5;
      } else if (field11 === "dropdown11Option3") {
        T = 1.5;
      } else if (field11 === "dropdown11Option4") {
        if (Number(field11a) <= 2) {
          T = 0;
        } else if (Number(field11a) > 3 && Number(field11a) <= 5) {
          T = -1.5;
        } else if (Number(field11a) > 5) {
          T = -3;
        }
      }
    }

    // S → Sleep Factor
    if (Number(field12) >= 7 && Number(field12) <= 8) {
      S = 3;
    } else if (Number(field12) >= 5 && Number(field12) < 7) {
      S = -2;
    } else if (Number(field12) > 8 && Number(field12) < 9) {
      S = -0.5;
    } else if (Number(field12) > 9) {
      S = -3;
    } else if (Number(field12) < 5) {
      S = -5;
    }

    // X → Meditation & Stress Factor
    if (field13 === "dropdown13Option1") {
      if (field14 === "dropdown14Option4") {
        X = -5;
      } else if (field14 === "dropdown14Option3") {
        X = -3;
      } else if (field14 === "dropdown14Option2") {
        X = -1;
      } else if (field14 === "dropdown14Option1") {
        X = 0;
      }
    } else if (field13 === "dropdown13Option2") {
      if (field14 === "dropdown14Option4") {
        X = -4;
      } else if (field14 === "dropdown14Option3") {
        X = -2;
      } else if (field14 === "dropdown14Option2") {
        X = 0;
      } else if (field14 === "dropdown14Option1") {
        X = 2;
      }
    } else if (field13 === "dropdown13Option3") {
      if (field14 === "dropdown14Option4") {
        X = -2;
      } else if (field14 === "dropdown14Option3") {
        X = -1;
      } else if (field14 === "dropdown14Option2") {
        X = 2;
      } else if (field14 === "dropdown14Option1") {
        X = 3;
      }
    } else if (field13 === "dropdown13Option4") {
      if (field14 === "dropdown14Option4") {
        X = 0;
      } else if (field14 === "dropdown14Option3") {
        X = 1;
      } else if (field14 === "dropdown14Option2") {
        X = 3;
      } else if (field14 === "dropdown14Option1") {
        X = 5;
      }
    }

    // D → City or street factor
    if (field2 === "männlich") {
      if (field15 === "Yes") {
        D = -1;
      } else if (field15 === "No") {
        D = 1;
      }
    } else if (field2 === "weiblich") {
      if (field15 === "Yes") {
        D = 0.5;
      } else if (field15 === "No") {
        D = 0.5;
      }
    }

    // R → Religion
    if (field16 === "No") {
      R = -2;
    } else if (field16 === "Yes") {
      if (field16a === "dropdown16Option1") {
        R = -2;
      } else if (field16a === "dropdown16Option2") {
        R = 3;
      } else if (field16a === "dropdown16Option3") {
        R = 5;
      } else if (field16a === "dropdown16Option4") {
        R = 7;
      }
    }

    // O → Optimism Factor
    if (field17 === "dropdown17Option1") {
      O = 1.07;
    } else if (field17 === "dropdown17Option2") {
      O = 1;
    } else if (field17 === "dropdown17Option3") {
      O = 0.93;
    }

    const L = Math.round((A * 0.4 + P * 0.6) * E * O * K + M + B + G + F + C + T + S + D + X + R - 4);

    if (secondButtonClicked) {
      setResultL2(L);
    } else {
      setResultL(L);
    }

    // g → gender factor for calculations of Sj and Sm
    if (field2 === "männlich") {
      g = 1;
    } else if (field2 === "weiblich") {
      g = 0.9;
    }

    // Sx →
    const sxCompare = Number(field19a) * 60 + Number(field19b);
    if (sxCompare < 60) {
      if (field18 === "dropdown18Option3") {
        Sx = 0.5;
      } else {
        Sx = 1;
      }
    } else if (sxCompare >= 60 && sxCompare < 100) {
      if (field18 === "dropdown18Option3") {
        Sx = 1;
      } else {
        Sx = 4;
      }
    } else if (sxCompare >= 100 && sxCompare < 150) {
      if (field18 === "dropdown18Option3") {
        Sx = 2.5;
      } else if (field18 === "dropdown18Option4") {
        Sx = 6.2;
      } else if (field18 === "dropdown18Option5") {
        Sx = 6.5;
      } else if (field18 === "dropdown18Option6") {
        Sx = 6.6;
      }
    } else if (sxCompare >= 150 && sxCompare < 300) {
      if (field18 === "dropdown18Option3") {
        Sx = 2.7;
      } else if (field18 === "dropdown18Option4") {
        Sx = 7.2;
      } else if (field18 === "dropdown18Option5") {
        Sx = 7.5;
      } else if (field18 === "dropdown18Option6") {
        Sx = 7.6;
      }
    } else if (sxCompare >= 300 && sxCompare < 500) {
      if (field18 === "dropdown18Option3") {
        Sx = 2.9;
      } else if (field18 === "dropdown18Option4") {
        Sx = 7.6;
      } else if (field18 === "dropdown18Option5") {
        Sx = 8.1;
      } else if (field18 === "dropdown18Option6") {
        Sx = 8.3;
      }
    } else if (sxCompare >= 500 && sxCompare < 700) {
      if (field18 === "dropdown18Option3") {
        Sx = 3;
      } else if (field18 === "dropdown18Option4") {
        Sx = 7.8;
      } else if (field18 === "dropdown18Option5") {
        Sx = 8.4;
      } else if (field18 === "dropdown18Option6") {
        Sx = 8.7;
      }
    } else if (sxCompare >= 700) {
      if (field18 === "dropdown18Option3") {
        Sx = 3;
      } else if (field18 === "dropdown18Option4") {
        Sx = 7.9;
      } else if (field18 === "dropdown18Option5") {
        Sx = 8.6;
      } else if (field18 === "dropdown18Option6") {
        Sx = 8.9;
      }
    }

    // FB → Years gained by casual biking
    const Fb =
      ((L - (currentYear - Number(field1)) - 10 + Number(field22)) * (Number(field20a) + field20b / 60) * 52) / 8760;

    // Sjf → Share of years gained by athletic biking
    const Sjf =
      field21a === 0 && field21b === 0
        ? 0
        : ((Number(field21a) * 60 + Number(field21b)) / (Number(field19a) * 60 + Number(field19b))) * Sx;

    // Fj → Years of life gained through biking
    const Fj = Math.floor(Fb + Sjf);

    // Fm → Months of life gained through biking
    const Fm = Math.round((Fb + Sjf - Fj) * 12);

    // Sj → Years of life gained through sports
    let Sj: number;
    if (field18 === "dropdown18Option2") {
      Sj = Math.floor(Fb);
    } else {
      Sj = Math.floor(Sx * g + Fb);
    }

    // Sm → Months of life gained through sports
    let Sm: number;
    if (field18 === "dropdown18Option2") {
      Sm = Math.round((Fb - Sj) * 12);
    } else {
      Sm = Math.round((Sx + Fb - Sj) * 12);
    }

    // Yj → Total life expectancy including sports and biking (years)
    const Yj = L + Sj;

    if (button === "last-button") {
      if (allFieldsAvailable) {
        setResultFj(Fj.toLocaleString(lang, { maximumFractionDigits: 2 }));
        setResultFm(Fm.toLocaleString(lang, { maximumFractionDigits: 2 }));
        setResultSj(Sj.toLocaleString(lang, { maximumFractionDigits: 2 }));
        setResultSm(Sm.toLocaleString(lang, { maximumFractionDigits: 2 }));
        setResultYj(Yj.toLocaleString(lang, { maximumFractionDigits: 2 }));
      } else {
        setErrorMessage(t("errorMessage1"));
      }
    }
  };

  return (
    <>
      <div className={classes.imageSpacing}>
        <CalculatorImage
          src="/images/calculators/lebenserwartungsrechner/Lebenserwartungsrechner-Header.svg"
          layout="intrinsic"
          alt={t("altTextImage1")}
        />
      </div>

      <CalculatorBodyText>{t("paragraph1")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph2")}</CalculatorBodyText>

      <CalculatorBodyText>
        {
          <>
            <span>{t("paragraph3a")}</span>
            <LocaleLink
              as={"https://www.uu.nl/en/news/dutch-bikers-live-six-months-longer"}
              href={"https://www.uu.nl/en/news/dutch-bikers-live-six-months-longer"}
              target="new"
              externalLink
            >
              {t("paragraph3Link")}
            </LocaleLink>
            <span>{t("paragraph3b")}</span>
          </>
        }
      </CalculatorBodyText>

      <CalculatorBodyText>
        <span>{t("paragraph4a")}</span>
        <LocaleLink as={"/blog/99-gruende-radfahren"} href={"/blog/99-gruende-radfahren"} target="new">
          {t("paragraph4Link")}
        </LocaleLink>
      </CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph5")}</CalculatorBodyText>
      <CalculatorButton text={t("scrollDownButton")} scroll idToScrollTo="calculator" />

      <CalculatorBodyText>
        <span className={classes.boldText}>{t("paragraph6aBold")}</span>
        <span>{t("paragraph6b")}</span>
      </CalculatorBodyText>

      <CalculatorBodyText>
        <span className={classes.boldText}>{t("paragraph7aBold")}</span>
        <span>{t("paragraph7b")}</span>
      </CalculatorBodyText>

      <div id="calculator" style={{ marginTop: "50px", marginBottom: "50px", textAlign: "center" }}>
        <CalculatorHeadline>{t("headline1")}</CalculatorHeadline>
      </div>

      <CalculatorInputSection
        inputTitle={t("inputTitle1")}
        inputNumber="1"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
        name="field1"
        value={fields?.field1}
      >
        {generateYears()?.map((el) => (
          <MenuItem key={el} value={el}>
            {el}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <div className={classes.dividerContainer}>
        <div className={classes.divider}></div>
        <img className={classes.dividerLabel} src={`/images/calculators/number_icons/orange_${2}.svg`} alt="number" />
        <CalculatorInputHeadline>{t("inputTitle2")}</CalculatorInputHeadline>
      </div>

      <div className={classes.genderContainer}>
        <div onClick={() => setFields({ ...fields, field2: "männlich" })} className={classes.genderWrapper}>
          <Maennlich altText={t("altTextImage2")} fillColor={fields?.field2 === "männlich" ? "#04B0E9" : "#ffffff"} />
        </div>
        <div onClick={() => setFields({ ...fields, field2: "weiblich" })} className={classes.genderWrapper}>
          <Weiblich altText={t("altTextImage2")} fillColor={fields?.field2 === "weiblich" ? "#04B0E9" : "#ffffff"} />
        </div>
      </div>

      <CalculatorInputSection
        inputTitle={t("inputTitle3")}
        inputNumber="3"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        name="field3"
        value={fields?.field3}
      >
        {fields?.field3 === "dropdown3Option1"
          ? dropdown3OptionsFirst?.map((el) => (
              <MenuItem key={el} value={el}>
                {t(el)}
              </MenuItem>
            ))
          : dropdown3Options?.map((el) => (
              <MenuItem key={el} value={el}>
                {t(el)}
              </MenuItem>
            ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle4")}
        inputNumber="4"
        bottomInputClass={classes.bottomInputClass}
        isSlider
        selectZr={fields?.field4}
        selectMaxZrLabel={"> 70.000 €"}
        selectMaxZr={70000}
        selectMinZrLabel={"< 30.000 €"}
        selectMinZr={10000}
        selectZrLabelUnit={labels?.field4}
        displayLabel={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChanges("field4", e)}
      />

      <CalculatorSlider
        sliderTopCenteredLabel={labels?.field5}
        sliderStep={10}
        minValue={10}
        maxValue={50}
        inputNumber={"5"}
        marks={sliderMarks}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChanges("field5", e)}
      />

      {fields.field5 === t("input5Label4") ? (
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
          <CalculatorInputHeadline>{t("inputTitle5a")}</CalculatorInputHeadline>
          <div className={classes.buttonsContainer}>
            <InputWithLabelAtTheBottom
              name="field5a"
              value={fields?.field5a}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
              label={t("years")}
            />
          </div>
        </div>
      ) : null}

      <CalculatorInputSection
        inputTitle={t("inputTitle6")}
        inputNumber="6"
        bottomInputClass={classes.bottomInputClass}
        isSlider
        selectZr={fields?.field6}
        selectMaxZrLabel={`100 ${t("years")}`}
        selectMaxZr={100}
        selectMinZrLabel={`50 ${t("years")}`}
        selectMinZr={50}
        selectZrLabelUnit={`${fields?.field6} ${t("years")}`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChanges("field6", e)}
      />

      <InputHeader inputNumber="7" inputTitle={t("inputTitle7")}>
        <div className={classes.buttonsContainer}>
          <>
            <InputWithLabelAtTheBottom
              name="field7a"
              value={fields?.field7a}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
              label={t("inputTitle7a")}
              inputUnite={"cm"}
            />
            <InputWithLabelAtTheBottom
              name="field7b"
              value={fields?.field7b}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
              label={t("inputTitle7b")}
              inputUnite={"kg"}
            />
          </>
        </div>
      </InputHeader>
      <div style={{ textAlign: "center" }}>
        {showQuestion7() ? (
          <>
            <H3Headline>{t("input7Caption1")}</H3Headline>
            <div style={{ marginTop: "30px" }}>
              <CalculatorInputSection
                isSelect
                isNotSection
                name="field7"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
                value={fields?.field7}
              >
                {dropdown7Options?.map((el) => (
                  <MenuItem key={el} value={el}>
                    {t(el)}
                  </MenuItem>
                ))}
              </CalculatorInputSection>
            </div>
          </>
        ) : null}

        {fields.field7 === "yes" ? (
          <>
            <H3Headline>{t("input7Caption2")}</H3Headline>
            <div style={{ marginTop: "30px" }}>
              <CalculatorInputSection
                isSelect
                isNotSection
                name="field7c"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
                value={fields?.field7c}
              >
                {dropdown7cOptions?.map((el) => (
                  <MenuItem key={el} value={el}>
                    {t(el)}
                  </MenuItem>
                ))}
              </CalculatorInputSection>
            </div>
          </>
        ) : null}
      </div>

      <CalculatorInputSection
        inputTitle={t("inputTitle8")}
        inputNumber="8"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field8}
        name="field8"
      >
        {dropdown8Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle9")}
        inputNumber="9"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field9}
        name="field9"
      >
        {dropdown9Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <div style={{ textAlign: "center" }}>
        <H3Headline>{t("input9Caption1")}</H3Headline>
        <CalculatorBodyText className={classes.marginTopZero}>{t("input9Caption2")}</CalculatorBodyText>
        <div style={{ marginTop: "30px" }}>
          <CalculatorInputSection
            isSelect
            isNotSection
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
            value={fields?.field9a}
            name="field9a"
          >
            {yesAndNoDropdown?.map((el) => (
              <MenuItem key={el} value={el}>
                {t(el)}
              </MenuItem>
            ))}
          </CalculatorInputSection>
        </div>
      </div>

      <CalculatorInputSection
        inputTitle={t("inputTitle10")}
        inputNumber="10"
        isSelect
        bottomInputCaption={<span>{t("input10Caption1")}</span>}
        bottomInputClass={classes.bottomInputClass}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field10}
        name="field10"
      >
        {dropdown10Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle11")}
        inputNumber="11"
        isSelect
        bottomInputClass={classes.bottomInputClass}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field11}
        name="field11"
      >
        {dropdown11Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      {fields?.field11 === "dropdown11Option4" ? (
        <div style={{ textAlign: "center" }}>
          <H3Headline>{t("inputTitle11a")}</H3Headline>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
            <InputWithLabelAtTheBottom
              name="field11a"
              value={fields?.field11a}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
              label={t("years")}
            />
          </div>
        </div>
      ) : null}

      <InputHeader inputNumber="12" inputTitle={t("inputTitle12")}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <>
            <InputWithLabelAtTheBottom
              name="field12"
              value={fields?.field12}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
              label={t("hours")}
            />
          </>
        </div>
      </InputHeader>

      <CalculatorInputSection
        inputTitle={t("inputTitle13")}
        inputNumber="13"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field13}
        name="field13"
      >
        {dropdown13Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle14")}
        inputNumber="14"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field14}
        name="field14"
      >
        {dropdown14Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle15")}
        inputNumber="15"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field15}
        name="field15"
      >
        {yesAndNoDropdown?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      <CalculatorInputSection
        inputTitle={t("inputTitle16")}
        inputNumber="16"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field16}
        name="field16"
      >
        {yesAndNoDropdown?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      {fields?.field16 === "Yes" ? (
        <div style={{ textAlign: "center" }}>
          <H3Headline>{t("inputTitle16a")}</H3Headline>
          <div style={{ marginTop: "30px" }}>
            <CalculatorInputSection
              isSelect
              isNotSection
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
              value={fields?.field16a}
              name="field16a"
            >
              {dropdown16Options?.map((el) => (
                <MenuItem key={el} value={el}>
                  {t(el)}
                </MenuItem>
              ))}
            </CalculatorInputSection>
          </div>
        </div>
      ) : null}

      <CalculatorInputSection
        inputTitle={t("inputTitle17")}
        inputNumber="17"
        isSelect
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        value={fields?.field17}
        name="field17"
      >
        {dropdown17Options?.map((el) => (
          <MenuItem key={el} value={el}>
            {t(el)}
          </MenuItem>
        ))}
      </CalculatorInputSection>

      {errorMessage ? <ErrorMessage message={errorMessage} /> : null}

      <CalculatorButton
        onClick={() => calculateResults("first")}
        text={secondButtonClicked ? t("calculateButtonb") : t("calculateButtona")}
      />
      {resultL ? <Result1 field2={fields?.field2} L={resultL} A={resultA} /> : null}
      {resultL2 ? (
        <div style={{ textAlign: "center" }}>
          <SecondPartOfTheResult L={resultL2} />
        </div>
      ) : null}

      {resultL ? (
        <>
          <CalculatorButton
            onClick={() => {
              setSecondButtonClicked(true);
              handleScroll("calculator");
            }}
            whiteBackground
            text={t("calculateButton1")}
          />
          <CalculatorButton
            text={t("calculateButton2")}
            onClick={() => {
              setSecondButtonClicked(false);
              setResultL(null);
              setResultL2(null);
              setFields(initialState);
            }}
          />
        </>
      ) : null}

      {resultL ? (
        <>
          <CalculatorBodyText>
            <span style={{ fontWeight: 700 }}>{t("paragraph12c")}</span>
            <span>{t("paragraph12d")}</span>
          </CalculatorBodyText>
          <CalculatorBodyText>
            <span style={{ fontWeight: 700 }}>{t("paragraph12a")}</span>
            <span>{t("paragraph12b")}</span>
          </CalculatorBodyText>

          <p className={classes.greenParagraph}>{t("paragraph13")}</p>

          <CalculatorBodyText>{t("paragraph14")}</CalculatorBodyText>

          <CalculatorInputSection
            inputTitle={t("inputTitle18")}
            inputNumber="18"
            isSelect
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
            value={fields?.field18}
            name="field18"
          >
            {fields?.field18 === "dropdown18Option1"
              ? dropdown18OptionsFirst?.map((el) => (
                  <MenuItem key={el} value={el}>
                    {t(el)}
                  </MenuItem>
                ))
              : dropdown18Options?.map((el) => (
                  <MenuItem key={el} value={el}>
                    {t(el)}
                  </MenuItem>
                ))}
          </CalculatorInputSection>

          {fields?.field18 !== "dropdown18Option2" ? (
            <InputHeader inputNumber="19" inputTitle={t("inputTitle19")}>
              <div className={classes.buttonsContainer}>
                <>
                  <InputWithLabelAtTheBottom
                    name="field19a"
                    value={fields?.field19a}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                    label={t("hours")}
                  />
                  <InputWithLabelAtTheBottom
                    name="field19b"
                    value={fields?.field19b}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                    label={t("minutes")}
                  />
                </>
              </div>
            </InputHeader>
          ) : null}

          <InputHeader
            inputNumber={fields?.field18 === "dropdown18Option2" ? "19" : "20"}
            inputTitle={t("inputTitle20")}
          >
            <div className={classes.buttonsContainer}>
              <>
                <InputWithLabelAtTheBottom
                  name="field20a"
                  value={fields?.field20a}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                  label={t("hours")}
                  disabled={twentyIsChecked}
                />
                <InputWithLabelAtTheBottom
                  name="field20b"
                  value={fields?.field20b}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                  label={t("minutes")}
                  disabled={twentyIsChecked}
                />
              </>
            </div>

            <div className={classes.checkboxContainer}>
              <input
                type="checkbox"
                id="check"
                name="check"
                checked={twentyIsChecked}
                onChange={() => {
                  setFields({ ...fields, field21a: 0, field21b: 0, field22: 0, field20a: 0, field20b: 0 });
                  setTwentyIsChecked(!twentyIsChecked);
                }}
              />
              {t("input20Checkbox")}
            </div>
          </InputHeader>

          {!twentyIsChecked ? (
            <InputHeader
              inputNumber={fields?.field18 === "dropdown18Option2" ? "20" : "21"}
              inputTitle={t("inputTitle21")}
            >
              <div className={classes.buttonsContainer}>
                <>
                  <InputWithLabelAtTheBottom
                    name="field21a"
                    value={fields?.field21a}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                    label={t("hours")}
                  />
                  <InputWithLabelAtTheBottom
                    name="field21b"
                    value={fields?.field21b}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                    label={t("minutes")}
                  />
                </>
              </div>
            </InputHeader>
          ) : null}

          {displayFirstErrorMessagesOnTwenty() ? <ErrorMessage message={`${t("input20ErrorMessage1")}`} /> : null}
          {displaySecondErrorMessagesOnTwenty() ? <ErrorMessage message={`${t("input20ErrorMessage2")}`} /> : null}

          {!twentyIsChecked ? (
            <InputHeader
              inputNumber={fields?.field18 === "dropdown18Option2" ? "21" : "22"}
              inputTitle={t("inputTitle22")}
            >
              <div className={classes.buttonsContainer}>
                <>
                  <InputWithLabelAtTheBottom
                    name="field22"
                    value={fields?.field22}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, true)}
                    label={t("years")}
                  />
                </>
              </div>
            </InputHeader>
          ) : null}

          {errorMessage ? <ErrorMessage message={errorMessage} /> : null}

          <CalculatorButton text={t("calculateButton3")} onClick={() => calculateResults("last-button")} />
          {resultYj ? (
            <Result2
              Fj={resultFj}
              Fm={resultFm}
              Sj={resultSj}
              Sm={resultSm}
              Yj={resultYj}
              fields={fields}
              twentyIsChecked={twentyIsChecked}
            />
          ) : null}
          <CalculatorBodyText>
            <LocaleLink as={"/blog/fahrrad-fahren-gesund"} href={"/blog/fahrrad-fahren-gesund"} target="new">
              {t("paragraph10Link")}
            </LocaleLink>
            {", "}
            <span>{t("paragraph10")}</span>
          </CalculatorBodyText>

          <CalculatorBodyText>{t("paragraph11")}</CalculatorBodyText>
          <CalculatorButtonLinkCentered text={t("calculateButton4")} href="/rechner/fahrrad-vs-auto-rechner" />
        </>
      ) : null}
    </>
  );
};

export default LebenserwartungsrechnerComponent;
